import { render, staticRenderFns } from "./SolidSquareRedX.vue?vue&type=template&id=24258c95&"
import script from "./SolidSquareRedX.vue?vue&type=script&lang=js&"
export * from "./SolidSquareRedX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports